import { useParams } from 'react-router'
import '../../../../Editor/editorStyles.css'

const ViewHtml = (props) => {
  const { id } = useParams()
  return (
    <div
      className='tl-employee-content-wrapper editor-data-styles h-100 scrollbar'
      style={
        props.hideCourseSidebar === 0 && props.collapse !== 'collapse'
          ? { right: 320, padding: 20 }
          : { padding: 20 }
      }
    >
      <div
        dangerouslySetInnerHTML={{
          __html: props.content.find((item) => item.id === parseInt(id))
            ? props.content.find((item) => item.id === parseInt(id)).html
            : null,
        }}
      />
    </div>
  )
}

export default ViewHtml
